var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBallPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.655056 57.8415C-4.21699 94.0315 21.1712 127.319 57.3612 132.191C93.5512 137.063 126.839 111.675 131.711 75.4848C136.583 39.2948 111.194 6.00746 75.0044 1.13541C38.8144 -3.73664 5.5271 21.6515 0.655056 57.8415Z",
    fill: "url(#paint0_radial_9404_215963)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9404_215963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.195 66.1491) rotate(97.6673) scale(106.921)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#621E81"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallPurple);
export default __webpack_public_path__ + "static/media/ball-purple.d5a45f63cbaddf781b4fba0a852c367d.svg";
export { ForwardRef as ReactComponent };